import type {
  WShopSearchEntityView,
  WProductView,
  WCollectionItemProductView,
} from '@zola/svc-web-api-ts-client';
import { convertCurrencyFormat } from '../../util/currencyFormatter';

const formatPriceForSegment = (centsPrice: number | undefined) => {
  if (!centsPrice) return null;
  // hide decimals if cents are zero
  const minPriceFractionDigits = (centsPrice / 100) % 1 > 0 ? 2 : 0;
  const formattedPrice = convertCurrencyFormat(
    centsPrice / 100,
    'USD',
    minPriceFractionDigits,
    2
  ) as string;
  return Number(formattedPrice.slice(1));
};

const getProductListViewedEventData = (
  products: WShopSearchEntityView[],
  trackedProductIndex: number,
  props: { eventData?: { location: string; section: string } }
) => {
  if (products.length === 0) return null;
  const { eventData } = props;
  if (!eventData) return null;
  const { location, section } = eventData; // undefined on brand page
  const productsData = [];

  for (let i = trackedProductIndex; i < products.length; i += 1) {
    const { product, kit } = products[i];
    const collectionItem = products[i].collection_item;

    if (product || collectionItem) {
      const item = (product || collectionItem) as WProductView | WCollectionItemProductView;
      const productLook = item.product_look_views?.[0];
      const sku = productLook?.sku_previews?.[0];
      const data = {
        product_id: item.id,
        sku: sku?.id,
        category: item.category_view && item.category_view.name,
        name: item.name,
        brand: item.brand && item.brand.name,
        variant: item.default_product_look_id,
        price: formatPriceForSegment(sku?.price_cents),
        quantity: item.suggested_quantity,
        position: i,
        url: `${window.location.origin}/shop/product/${productLook?.key}`,
      };
      productsData.push(data);
    } else if (kit) {
      // since kits lack some data that products have those missing properties will have null values
      const data = {
        product_id: kit.id,
        sku: null,
        category: 'KITS',
        name: kit.name,
        brand: kit.brand && kit.brand.name,
        variant: null,
        price: null,
        quantity: null,
        position: i,
        url: `${window.location.origin}/shop/kit/${kit.key}`,
      };
      productsData.push(data);
    }
  }
  return {
    products: productsData,
    location,
    section,
    endpoint_variant: null,
    recommendation_source: null,
  };
};

export default getProductListViewedEventData;
